import axiosClient from 'api/axiosClient'

export const getMenu = () => {
  return (dispatch, getState) => {
    return axiosClient.get(`/menuItem/1`).then(response => {
      dispatch({
        type: 'GET_MENU',
        menu: standardNavbar(response.data ? response.data : [])
      })
    })
  }
}

export const getSidebar = () => {

  return (dispatch, getState) => {
    dispatch({
      type: 'GET_SIDEBAR',
      menuSelect: getState().menu.menuSelected
    })
  }
}
export const getBreadCrumb = () => {

  return (dispatch, getState) => {
    dispatch({
      type: 'GET_BREADCRUMB',
      breadCrumb: getState().menu.breadCrumb
    })
  }
}
export const updateMenuSelected = (selectedItem, selectedDetail, image) => {

  return dispatch => {
    const breadCrumbArr = standardBreadCrumb(selectedItem, selectedDetail)


    dispatch({
      type: 'UPDATE_SELECTMENU',
      selectedItem,
      selectedDetail,
      breadCrumbArr,
      image
    })

  }

}

export const updateMenuResearch = (menuResearch) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_RESEARCH',
      menuSelected: menuResearch
    })
  }
}
export const updateMenuPatent = (menuPatent) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PATENT',
      menuSelected: menuPatent
    })
  }
}

export const updateCategory = (categoryArr = [], selectedDetail = {}) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_CATEGORYNEWS',
      categoryArr: categoryArr,
      selectedDetail: selectedDetail
    })
  }
}
export const updateSelecteDetail = (selectedDetail = {}) => {

  return dispatch => {
    dispatch({
      type: 'UPDATE_SELECTEDETAIL',
      selectedDetail: selectedDetail
    })
  }
}
export const updateBreadCrumbNews = (menuArr) => {

  return dispatch => {
    dispatch({
      type: 'UPDATE_BREADCRUMBNEWS',
      breadCrumbArr: menuArr
    })
  }
}

const standardLink = (dataMenu, prefix, homePath) => {
  let path = ''
  let flag = false
  if (dataMenu && Array.isArray(dataMenu) && dataMenu.length > 0) {
    dataMenu.map((item, index) => {
      if (item.type === "CUSTOM_PAGE" && !flag) {
        path = `${prefix}/page/${homePath}/${item.path}`
        flag = true
      }
    })
  }
  return path
}
const standardNavbar = (dataMenu) => {
  const isVietnamese = window.location.pathname.startsWith('/vi')
  const prefix = isVietnamese ? '/vi' : ''
  const homePath = 'Home'

  let menuArr = []

  if (dataMenu) {
    dataMenu.map((item, index) => {
      let menuItem = {
        id: item.id,
        url: item.url,
        type: item.type,
        path: item.path ? item.path : "",
        title: item.title,
        children: []
      }

      let flag = false

      if (item.type === "INCLUDE" && item.children !== undefined) {
        item.children.map((ele, ind) => {
          let childrenItem = {
            id: ele.id,
            url: ele.url,
            type: ele.type,
            path: ele.path ? ele.path : "",
            title: ele.title
          }

          if (ele.type === "INCLUDE" && ele.children !== undefined) {
            childrenItem.path = prefix + standardLink(ele.children, prefix, homePath)
            if (!flag) {
              menuItem.path = childrenItem.path
              flag = true
            }
          } else if (ele.type === "CUSTOM_PAGE") {
            childrenItem.path = `${prefix}/page/${homePath}/${ele.path}`
            if (!flag) {
              menuItem.path = childrenItem.path
              flag = true
            }
          } else if (ele.type === "PUBLICATION_COLLECTIONS") {
            childrenItem.path = `${prefix}/research/list`
            if (!flag) {
              menuItem.path = childrenItem.path
              flag = true
            }
          } else if (ele.type === "PATENTS_COLLECTIONS") {
            childrenItem.path = `${prefix}/patent/list`
            if (!flag) {
              menuItem.path = childrenItem.path
              flag = true
            }
          } else if (ele.type === "PARTNER_COLLECTIONS") {
            childrenItem.path = `${prefix}/partner/list`
            if (!flag) {
              menuItem.path = childrenItem.path
              flag = true
            }
          }

          menuItem.children.push(childrenItem)
        })
      } else if (item.type === "CUSTOM_PAGE") {
        menuItem.path = `${prefix}/page/${homePath}/${item.path}`
      }

      menuArr.push(menuItem)
    })
  }

  return menuArr
}

// const standardBreadCrumb = (dataAllMenu, dataMenuSelected, unit_id) => {
//   // Xác định prefix ngôn ngữ
//   let langPrefix = unit_id === 0 ? "/vi/" : "";

//   let breadCrumbArr = [
//     {
//       title: unit_id === 0 ? "Trang chủ" : "Home",
//       path: langPrefix || "/" // Home cũng cần prefix
//     }
//   ];
//   console.log(breadCrumbArr)

//   let flag = false;
//   // Push cấp 1
//   breadCrumbArr.push({
//     title: dataAllMenu.title,
//     path: langPrefix + dataAllMenu.path
//   });
//   console.log(dataAllMenu)

//   if (dataAllMenu.type === "INCLUDE" && dataAllMenu.children !== undefined) {
//     dataAllMenu.children.map((item, index) => {
//       if (item.type === "INCLUDE" && item.children !== undefined && !flag) {
//         item.children.map((temp, inde) => {
//           if (temp.path === dataMenuSelected.path && !flag) {
//             breadCrumbArr.push({
//               title: item.title,
//               path: langPrefix + item.path
//             });
//             breadCrumbArr.push({
//               title: dataMenuSelected.title,
//               path: langPrefix + dataMenuSelected.path
//             });
//             flag = true;
//             return breadCrumbArr;
//           }
//         });
//       } else if (item.path === dataMenuSelected.path && !flag) {
//         breadCrumbArr.push({
//           title: dataMenuSelected.title,
//           path: langPrefix + dataMenuSelected.path
//         });
//         flag = true;
//         return breadCrumbArr;
//       }
//     });
//   } else if (dataAllMenu.path === dataMenuSelected.path && !flag) {
//     breadCrumbArr.push({
//       title: dataMenuSelected.title,
//       path: langPrefix + dataMenuSelected.path
//     });
//     flag = true;
//   }
//   console.log(breadCrumbArr)

//   return breadCrumbArr;
// };

const standardBreadCrumb = (dataAllMenu, dataMenuSelected) => {
  const isVietnamese = window.location.pathname.startsWith('/vi')
  const prefix = isVietnamese ? '/vi' : ''
  let breadCrumbArr = [
    {
      title: "Home",
      path: prefix || "/"
    }
  ]
  let flag = false
  breadCrumbArr.push({
    title: dataAllMenu.title,
    path: dataAllMenu.path
  })
  if (dataAllMenu.type === "INCLUDE" && dataAllMenu.children !== undefined) {
    dataAllMenu.children.map((item, index) => {
      if (item.type === "INCLUDE" && item.children !== undefined && !flag) {
        item.children.map((temp, inde) => {
          if (temp.path === dataMenuSelected.path && !flag) {
            breadCrumbArr.push({
              title: item.title,
              path: item.path
            })
            breadCrumbArr.push({
              title: dataMenuSelected.title,
              path: dataMenuSelected.path
            })
            flag = true
            return breadCrumbArr
          }
        })
      }
      else if (item.path === dataMenuSelected.path && !flag) {
        breadCrumbArr.push({
          title: dataMenuSelected.title,
          path: dataMenuSelected.path
        })
        flag = true
        return breadCrumbArr
      }
    })
  }
  else if (dataAllMenu.path === dataMenuSelected.path && !flag) {
    breadCrumbArr.push({
      title: dataMenuSelected.title,
      path: dataMenuSelected.path
    })
    flag = true
  }
  return breadCrumbArr
}